module.exports = __webpack_public_path__ + "images/c15cd7b07aa696ecaa766dd2ebac3e35.svg";